/**
 * Internal dependencies
 */
import WelcomeGuideEditor from './editor';
import WelcomeGuideStyles from './styles';

export default function WelcomeGuide() {
	return (
		<>
			<WelcomeGuideEditor />
			<WelcomeGuideStyles />
		</>
	);
}
